import React, { useState, useMemo } from 'react';
import { Icon } from 'semantic-ui-react';
import { useSubscription } from 'utils';
import request from 'services/http';
import { tap, finalize } from 'rxjs/operators';

export default function Carrossel({ measure }) {
    const [image, setImage] = useState({});
    const [imagesList, setImagesList] = useState(new Map());

    const getImages = useMemo(() => {
        const req = request({ method: 'GET', url: `/combustivel/afericao/fotos/${measure}` }).pipe(
            tap(({ response }) => {
                const items = new Map();

                for (const item of response) {
                    if (item.id === 1) {
                        setImage({ id: 1, link: item.link });
                    }
                    items.set(item.id, item.link);
                }

                setImagesList(items);
            }),
            finalize(() => req.unsubscribe),
        );

        return req;
    }, [measure]);

    useSubscription(getImages);

    const carouselOption = (id, link, focus = false) => (
        <div
            onClick={() => moveTo(id)}
            className={`list-item ${focus ? 'focus' : ''}`}
            key={Math.random()}
        >
            <img className="carousel-img" src={link} alt="Cupom miniatura" />
        </div>
    );

    const createCarousel = () => {
        const items = [];
        const focus = image.id;

        for (let i = -2; i < 3; i++) {
            if (focus + i > 0 && focus + i <= imagesList.size) {
                items.push(carouselOption(focus + i, imagesList.get(focus + i), i === 0));
            } else if (i === 2) {
                const image = 2 - (imagesList.size - focus);
                items.push(carouselOption(image, imagesList.get(image)));
            } else if (i === 1) {
                items.push(carouselOption(1, imagesList.get(1)));
            } else if (i === -2) {
                const last = imagesList.size;
                items.push(carouselOption(last, imagesList.get(last)));
            } else if (i === -1) {
                const penult = imagesList.size - 1;
                items.push(carouselOption(penult, imagesList.get(penult)));
            }
        }

        return items;
    };

    const moveRight = () => {
        const next = image.id + 1 > imagesList.size ? 1 : image.id + 1;
        const newImage = imagesList.get(next);

        setImage({ id: next, link: newImage });
    };

    const moveLeft = () => {
        const next = image.id - 1 > 0 ? image.id - 1 : imagesList.size;
        const newImage = imagesList.get(next);

        setImage({ id: next, link: newImage });
    };

    const moveTo = (id) => {
        if (id === image.id) {
            return;
        }

        setImage({ id, link: imagesList.get(id) });
    };

    return (
        <div className="carousel">
            <div className="focus-photo">
                <img src={image.link} alt="Cupom" />
            </div>
            <p className="subtitle">Cupom {image.id}</p>

            <div className="photos-list">
                <div className="pass-button" onClick={() => moveLeft()}>
                    <Icon size="large" name="angle left" />
                </div>

                {createCarousel()}

                <div className="pass-button" onClick={() => moveRight()}>
                    <Icon size="large" name="angle right" />
                </div>
            </div>
        </div>
    );
}
